module.exports = __webpack_public_path__ + "static/media/icon-hitorico.4749a5db.svg";